import type { ReactNode } from 'react'

import { cn } from '@/lib/cn'

export interface PageHeaderProps {
  /** Small uppercase line above the title — a date, a context, a count. */
  eyebrow?: ReactNode
  title: ReactNode
  /** One sentence saying what the page is FOR, not what it contains. */
  subtitle?: ReactNode
  /** Primary and secondary actions, right-aligned. */
  actions?: ReactNode
  className?: string
}

export function PageHeader({
  eyebrow,
  title,
  subtitle,
  actions,
  className,
}: PageHeaderProps) {
  return (
    <header
      className={cn(
        'flex flex-wrap items-start justify-between gap-4',
        className,
      )}
    >
      <div className="flex min-w-0 flex-col gap-1.5">
        {eyebrow ? <span className="asa-eyebrow">{eyebrow}</span> : null}
        {/* Headings are Regular, never bold — the guideline assigns Regular to
            headlines. */}
        <h1 className="text-text-heading text-[31px] leading-none font-normal tracking-[-1px]">
          {title}
        </h1>
        {subtitle ? (
          <p className="text-text-muted text-[15px] leading-normal font-light">
            {subtitle}
          </p>
        ) : null}
      </div>
      {actions ? (
        <div className="flex shrink-0 items-center gap-2 pt-1">{actions}</div>
      ) : null}
    </header>
  )
}
